export const paginationObj = Object.freeze({
    totalCount: 0,
    pageSize: 10,
    pageNo: 1,
})

export const MembershipType = Object.freeze({
    ASSOCIATE: 1,
    FELLOW: 2,
    LIFEFELLOW: 3,
    STUDENTASSOCIATE: 4,
    NONMEMBER: 6,
    HONORARY_FELLO: 7,
    OTHER: 0,
})

export const ApplicationStatus = Object.freeze({
    Submitted: 2,
    ClarificationSubmitted: 7,
    SendClarification: 11,
    PendingApplicationFeeApproval: 13,
    PendingAdmissionCommittee: 14,
    AdmissionCommitteeComplete: 15,
    PendingBoardApproval: 16,
    BoardApproved: 17,
})

export const FolderName = Object.freeze({
    ImagePaymentProof: 'PaymentProof',
    FilePaymentProof: 'profOfPaymentFile',
})
